import { requestBuilder } from '../../../http/RequestBuilder';

const useUpdatePaycheckConfig = requestBuilder.mutation<null, null, null>({
    endpoint: '/api/paycheck-routing/delete',
    method: 'DELETE',
});

export default useUpdatePaycheckConfig;
